import { Avatar } from "primereact/avatar";
import MeaLink from "../../../components/MeaLink";
import { Badge } from "primereact/badge";
import { Tooltip } from "primereact/tooltip";
import { useParams } from "react-router-dom";


const MeaTeacherAvatar = ({ teacher, substitute, permission, noNavigation, schoolId, trainingId }) => {
  return (
    teacher && (
      <MeaLink
        to={"/school/" + schoolId + "/admin/trainings/" + trainingId + "/teachers/" + teacher?.id}
        permission={permission}
        noNavigation={noNavigation}

      >
        <div className="flex flex-row align-items-center">
          <Avatar
            className="mr-2 p-overlay-badge"
            icon="pi pi-user"
            shape="circle"
            image={
              teacher?.member?.avatar
                ? teacher?.member?.avatar + "?u=" + teacher?.member?.updated_at
                : ""
            }
            label={
              teacher?.member?.lastname
                ? Array.from(teacher?.member?.lastname)[0] +
                (teacher?.member?.firstname
                  ? Array.from(teacher?.member?.firstname)[0]
                  : "")
                : teacher?.member?.name
                  ? Array.from(teacher?.member?.name)[0]
                  : ""
            }
            size="normal"
          >
            {substitute && substitute?.id !== teacher?.id && (
              <>
                <Tooltip target=".custom-target-icon" />
                <Badge
                  size="normal"
                  className="custom-target-icon"
                  data-pr-tooltip={`${teacher?.member?.name ||
                    teacher?.member?.lastname + " " + teacher?.member?.firstname
                    } remplace ${substitute?.member?.name ||
                    substitute?.member?.lastname +
                    " " +
                    substitute?.member?.firstname
                    }`}
                  data-pr-position="right"
                  data-pr-at="right+5 top"
                  data-pr-my="left center-2"
                  severity="warning"
                  tooltip="hello"
                  value={
                    <i
                      className="pi pi-arrow-right-arrow-left"
                      style={{ fontSize: "0.7rem" }}
                    ></i>
                  }
                />
              </>
            )}
          </Avatar>
          <span className="text-left">
            {teacher?.member?.name ||
              teacher?.member?.lastname + " " + teacher?.member?.firstname}
          </span>
        </div>
      </MeaLink>
    )
  );
};
export default MeaTeacherAvatar;
